var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _ellipse3, _path10, _ellipse4, _ellipse5, _ellipse6, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExempleRapport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 396,
    height: 497,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4E9C7",
    stroke: "url(#a)",
    strokeMiterlimit: 10,
    strokeWidth: 9.195,
    d: "M373.14 5H22.86C12.996 5 5 12.84 5 22.51v459.516c0 9.67 0 9.67 9.864 9.67H373.14c17.86 0 17.86 0 17.86-17.51V22.509C391 12.84 383.004 5 373.14 5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#252A60",
    d: "M21.836 5h350.216C382.516 5 391 13.701 391 24.433v29.828c0 .947-.759 1.726-1.684 1.726H6.684C5.759 55.987 5 55.208 5 54.26V22.3C5 12.753 12.56 5 21.869 5h-.033Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.916 204.317h227.641v9.27H108.916zm0 18.54h227.641v9.27H108.916zm0-83.436h227.641v9.27H108.916zm0 18.542h227.641v9.27H108.916zm0 101.974h227.641v9.27H108.916zm0 18.542h227.641v9.27H108.916zm0 41.72h227.641v9.27H108.916zm0 18.541h227.641v9.27H108.916z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#03A300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.13,
    d: "m77.108 142.049-19.86 23.824-9.782-8.934m29.642 45.594-19.86 25.147-9.782-9.43m29.642 43.448-19.86 22.501-9.782-8.438"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DC0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.13,
    d: "m47.465 318.379 29.643 29.118m0-29.118-29.643 29.118"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2C48",
    d: "M141.7 419.396c-.022 9.854-3.086 19.485-8.792 27.634-5.706 8.15-13.788 14.438-23.19 18.044a51.26 51.26 0 0 1-29.508 2.166c-9.822-2.194-18.725-7.236-25.545-14.466-6.82-7.23-11.24-16.311-12.682-26.058-1.442-9.746.161-19.704 4.6-28.571s11.506-16.231 20.28-21.129a51.212 51.212 0 0 1 28.892-6.325l-4.171 48.813 50.116-.108Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3A156",
    d: "M98.554 370.812c11.645.577 22.604 5.546 30.649 13.897a45.246 45.246 0 0 1 12.664 31.061l-45.882.641 2.569-45.599Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E2C48",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.108,
    d: "M209.165 381.56v80.221l124.347.738"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E2C48",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.065,
    d: "m229.132 433.612 22.406-28.049 36.334 7.407 36.159-32.975"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.351,
    cy: 5.957,
    fill: "#1E2C48",
    rx: 6.351,
    ry: 5.957,
    transform: "matrix(.99877 .04947 -.05625 .99842 245.245 398.623)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.351,
    cy: 5.957,
    fill: "#1E2C48",
    rx: 6.351,
    ry: 5.957,
    transform: "matrix(.99877 .04947 -.05625 .99842 282.989 405.797)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.351,
    cy: 5.957,
    fill: "#1E2C48",
    rx: 6.351,
    ry: 5.957,
    transform: "matrix(.99877 .04947 -.05625 .99842 318.765 373.108)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF6B00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.065,
    d: "m234.149 445.119 22.149-16.796 24.072 11.796 47.782-20.165"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.351,
    cy: 5.957,
    fill: "#FF6B00",
    rx: 6.351,
    ry: 5.957,
    transform: "matrix(.99877 .04947 -.05625 .99842 275.809 433.266)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.351,
    cy: 5.957,
    fill: "#FF6B00",
    rx: 6.351,
    ry: 5.957,
    transform: "matrix(.99877 .04947 -.05625 .99842 249.621 421.365)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.351,
    cy: 5.957,
    fill: "#FF6B00",
    rx: 6.351,
    ry: 5.957,
    transform: "matrix(.99877 .04947 -.05625 .99842 322.168 413.032)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3A156",
    d: "m152.319 115.636-10.062-5.067c-.776-.38-1.722-.412-2.498 0l-10.129 4.909c-1.993.95-4.288-.633-3.883-2.692l2.026-10.515c.168-.824-.136-1.647-.743-2.249l-8.104-7.538c-1.587-1.489-.675-4.023 1.52-4.308l11.311-1.457c.878-.126 1.654-.633 2.026-1.361l5.132-9.566c1.013-1.868 3.849-1.837 4.828.032l4.963 9.629c.372.76 1.148 1.266 2.026 1.393l11.277 1.615c2.195.317 3.073 2.883 1.452 4.308l-8.238 7.411c-.642.57-.946 1.425-.811 2.217l1.824 10.547c.371 2.059-1.959 3.611-3.917 2.629v.063Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.875 99.61a5.156 5.156 0 0 0-1.046-1.362l-5.301-4.91a1.864 1.864 0 0 1-.507-1.963c.237-.697.878-1.204 1.655-1.299l7.36-.95c1.722-.222 3.242-1.235 4.018-2.692l3.343-6.24c.338-.665 1.047-1.045 1.823-1.045.777 0 1.486.412 1.823 1.077l1.655 3.2-.507.22-1.654-3.198c-.236-.475-.743-.76-1.317-.76s-1.047.285-1.317.76l-3.342 6.24c-.878 1.615-2.533 2.723-4.457 2.977l-7.361.95c-.574.063-1.013.412-1.182.918a1.278 1.278 0 0 0 .372 1.394l5.301 4.91c.473.442.844.95 1.148 1.488l-.507.253v.032Zm.969 12.196c-.372 0-.743-.159-1.047-.38-.642-.444-.946-1.172-.81-1.869l1.012-5.258.574.095-1.013 5.258c-.101.538.102 1.013.574 1.33a1.602 1.602 0 0 0 1.554.127l6.617-3.199c1.689-.824 3.782-.792 5.47.032l6.55 3.294a1.522 1.522 0 0 0 1.554-.096c.472-.316.675-.823.607-1.33l-1.181-6.904c-.304-1.806.337-3.611 1.722-4.878l5.368-4.846c.405-.38.54-.887.371-1.393-.168-.507-.607-.856-1.181-.95l-7.361-1.077a5.44 5.44 0 0 1-2.127-.729l.304-.475c.608.348 1.249.57 1.924.665l7.361 1.077c.777.127 1.384.602 1.621 1.33.236.697 0 1.457-.541 1.964l-5.368 4.846c-1.249 1.14-1.857 2.787-1.553 4.371l1.182 6.904c.135.729-.203 1.425-.845 1.869a2.19 2.19 0 0 1-2.16.127l-6.551-3.294c-1.519-.76-3.41-.792-4.929-.032l-6.618 3.199c-.338.158-.743.253-1.114.222h.034Z",
    opacity: 0.52
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3A156",
    d: "m209.738 115.636-10.062-5.067c-.776-.38-1.722-.412-2.498 0l-10.129 4.909c-1.992.95-4.288-.633-3.883-2.692l2.026-10.515c.168-.824-.135-1.647-.743-2.249l-8.104-7.538c-1.587-1.489-.675-4.023 1.52-4.308l11.311-1.457c.878-.126 1.654-.633 2.026-1.361l5.132-9.566c1.013-1.868 3.849-1.837 4.828.032l4.963 9.629c.372.76 1.148 1.266 2.026 1.393l11.277 1.615c2.195.317 3.073 2.883 1.452 4.308l-8.238 7.411c-.642.57-.946 1.425-.81 2.217l1.823 10.547c.371 2.059-1.959 3.611-3.917 2.629v.063Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.294 99.61a5.156 5.156 0 0 0-1.046-1.362l-5.301-4.91a1.866 1.866 0 0 1-.507-1.963c.237-.697.878-1.204 1.655-1.299l7.36-.95c1.722-.222 3.242-1.235 4.018-2.692l3.343-6.24c.338-.665 1.047-1.045 1.823-1.045.777 0 1.486.412 1.823 1.077l1.655 3.2-.507.22-1.654-3.198c-.236-.475-.743-.76-1.317-.76s-1.047.285-1.317.76l-3.342 6.24c-.878 1.615-2.533 2.723-4.457 2.977l-7.361.95c-.574.063-1.013.412-1.181.918a1.276 1.276 0 0 0 .371 1.394l5.301 4.91c.473.442.844.95 1.148 1.488l-.507.253v.032Zm.969 12.196c-.372 0-.743-.159-1.047-.38-.642-.444-.945-1.172-.81-1.869l1.012-5.258.574.095-1.012 5.258c-.102.538.101 1.013.574 1.33a1.6 1.6 0 0 0 1.553.127l6.617-3.199c1.689-.824 3.782-.792 5.47.032l6.551 3.294a1.52 1.52 0 0 0 1.553-.096c.472-.316.675-.823.607-1.33l-1.181-6.904c-.304-1.806.337-3.611 1.722-4.878l5.368-4.846c.405-.38.54-.887.372-1.393-.169-.507-.608-.856-1.182-.95l-7.361-1.077a5.44 5.44 0 0 1-2.127-.729l.304-.475a5.34 5.34 0 0 0 1.925.665l7.36 1.077c.777.127 1.384.602 1.621 1.33.236.697 0 1.457-.54 1.964l-5.369 4.846c-1.249 1.14-1.857 2.787-1.553 4.371l1.182 6.904c.135.729-.203 1.425-.844 1.869a2.191 2.191 0 0 1-2.161.127l-6.551-3.294c-1.519-.76-3.41-.792-4.929-.032l-6.618 3.199c-.338.158-.743.253-1.114.222h.034Z",
    opacity: 0.52
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3A156",
    d: "m267.157 115.636-10.061-5.067c-.777-.38-1.722-.412-2.499 0l-10.129 4.909c-1.992.95-4.288-.633-3.883-2.692l2.026-10.515c.169-.824-.135-1.647-.743-2.249l-8.103-7.538c-1.587-1.489-.676-4.023 1.519-4.308l11.311-1.457c.878-.126 1.654-.633 2.026-1.361l5.132-9.566c1.013-1.868 3.849-1.837 4.828.032l4.964 9.629c.371.76 1.148 1.266 2.025 1.393l11.278 1.615c2.194.317 3.072 2.883 1.452 4.308l-8.239 7.411c-.641.57-.945 1.425-.81 2.217l1.823 10.547c.371 2.059-1.958 3.611-3.917 2.629v.063Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M244.714 99.61a5.181 5.181 0 0 0-1.047-1.362l-5.301-4.91a1.866 1.866 0 0 1-.507-1.963c.237-.697.878-1.204 1.655-1.299l7.361-.95c1.721-.222 3.241-1.235 4.017-2.692l3.343-6.24c.338-.665 1.047-1.045 1.823-1.045.777 0 1.486.412 1.824 1.077l1.654 3.2-.506.22-1.655-3.198c-.236-.475-.743-.76-1.317-.76s-1.046.285-1.316.76l-3.343 6.24c-.878 1.615-2.532 2.723-4.457 2.977l-7.361.95c-.574.063-1.012.412-1.181.918a1.276 1.276 0 0 0 .371 1.394l5.301 4.91c.473.442.844.95 1.148 1.488l-.506.253v.032Zm.968 12.196c-.372 0-.743-.159-1.047-.38-.641-.444-.945-1.172-.81-1.869l1.013-5.258.574.095-1.013 5.258c-.102.538.101 1.013.574 1.33a1.6 1.6 0 0 0 1.553.127l6.618-3.199c1.688-.824 3.781-.792 5.469.032l6.551 3.294a1.52 1.52 0 0 0 1.553-.096c.473-.316.675-.823.608-1.33l-1.182-6.904c-.304-1.806.338-3.611 1.722-4.878l5.368-4.846c.406-.38.541-.887.372-1.393-.169-.507-.608-.856-1.182-.95l-7.361-1.077a5.44 5.44 0 0 1-2.127-.729l.304-.475a5.34 5.34 0 0 0 1.925.665l7.36 1.077c.777.127 1.385.602 1.621 1.33.236.697 0 1.457-.54 1.964l-5.369 4.846c-1.249 1.14-1.857 2.787-1.553 4.371l1.182 6.904c.135.729-.203 1.425-.844 1.869a2.191 2.191 0 0 1-2.161.127l-6.55-3.294c-1.52-.76-3.411-.792-4.93-.032l-6.618 3.199c-.337.158-.743.253-1.114.222h.034Z",
    opacity: 0.52
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 198,
    x2: 198,
    y1: 5,
    y2: 491.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3780"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExempleRapport);
export default __webpack_public_path__ + "static/media/exempleRapport.7762a0aab97078c53b5daf0a9b0584b4.svg";
export { ForwardRef as ReactComponent };